import { TimeOfDay } from "@pulse/pulse-rpcs/lib/email-cycle/timeOfDay";
import { Instance, SnapshotIn, types } from "mobx-state-tree";

export const TimeOfDayModel = types
  .model("TimeOfDayModel", {
    hour: types.integer,
    minute: types.integer,
  })
  .views((store) => ({
    get rpcObject(): TimeOfDay {
      return new TimeOfDay(store.hour, store.minute);
    },
  }))
  .actions((store) => ({
    setTimeOfDay: (
      hour: SnapshotIn<typeof TimeOfDayModel>["hour"],
      minute: SnapshotIn<typeof TimeOfDayModel>["minute"],
    ): void => {
      store.hour = hour;
      store.minute = minute;
    },
  }));

export const createTimeOfDayModel = (
  timeOfDayModel?: SnapshotIn<typeof TimeOfDayModel>,
): Instance<typeof TimeOfDayModel> =>
  TimeOfDayModel.create(
    timeOfDayModel ?? {
      hour: new Date().getHours(),
      minute:
        new Date().getMinutes() > 0 && new Date().getMinutes() < 30 ? 30 : 0,
    },
  );
